export const PORTFOLIO_PERMISSION = {
  VIEW_PORTFOLIO: 'urn:replicon:portfolio-action:view-portfolio',
  EDIT_PORTFOLIO: 'urn:replicon:portfolio-action:edit-portfolio',
  VIEW_COST_DATA: 'urn:replicon:portfolio-action:view-cost-data',
  EDIT_COST_DATA: 'urn:replicon:portfolio-action:edit-cost-data'
};
